import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { RuntimeContext } from '../../../../../common/RuntimeContext';
import {
    deleteFileByMetadataId,
    getFileWithSignedUrl,
    getManyFilesMetadata,
    getManyTeamsAdmin
} from '../../../../shared/actions';
import Page from '../../../../shared/components/Page';
import PageHeader from '../../../../shared/components/PageHeader';
import VerbButton from '../../../../shared/components/VerbButton';
import VerbTable from '../../../../shared/components/VerbTable';
import MediaLibraryRow from './MediaLibraryRow';

class MediaLibrary extends Component {
    static propTypes = {
        isVerbAdmin: PropTypes.bool,
        isAccountOwner: PropTypes.bool,
        isContentAuthor: PropTypes.bool,
        loggedInUser: PropTypes.object,
        getManyTeamsAdmin: PropTypes.func,
        teamsById: PropTypes.object
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);

        this.state = {
            filesMetadata: [],
            currentFileEditKey: '',
            copiedUrl: ''
        };
    }

    componentDidMount() {
        const { loggedInUser, getManyTeamsAdmin } = this.props;
        const companyId = loggedInUser && loggedInUser.companyId;

        return getManyFilesMetadata({pathsContext: this.context.pathsWeb}).then((filesMetadata) => {
            if (companyId) {
                getManyTeamsAdmin({ parentId: companyId, pathsContext: this.context.pathsWeb });
            }
            this.setState({
                filesMetadata
            });
        });
    }

    setCopiedUrl = (fileMetadata) => {
        this.setState({
            copiedUrl: `${this.context.pathsWeb.mediaLibraryUrl}/file/${fileMetadata.key}`
        });
    };

    handleDeleteFile = (file, index) => {
        // eslint-disable-next-line no-alert
        const confirmation = window.confirm(`Are you sure you want to delete ${file.fileName}?`);

        if (confirmation) {
            const params = {
                fileMetadataId: file._id,
                pathsContext: this.context.pathsWeb
            };

            return deleteFileByMetadataId(params).then(() =>
                this.setState((prevState) => {
                    const updatedFilesMetadata = [
                        ...prevState.filesMetadata.slice(0, index),
                        ...prevState.filesMetadata.slice(index + 1)
                    ];
                    return { filesMetadata: updatedFilesMetadata };
                })
            );
        }
        return null;
    };

    _filterMetaData = (mediaMetadata) => {
        const { isVerbAdmin, isContentAdmin, loggedInUser, teamsById = {} } = this.props;
        const teamsArray = Object.keys(teamsById);
        const companyId = loggedInUser && loggedInUser.companyId;

        return (mediaMetadata || []).filter(
            (file) =>
                (isVerbAdmin ? file.isPublic : false) ||
                (file.licenses || []).some(
                    (license) => license.parentId === companyId || teamsArray.includes(license.parentId)
                ) ||
                isVerbAdmin || isContentAdmin
        );
    };

    render() {
        const { filesMetadata, currentFileEditKey } = this.state;
        const { isVerbAdmin, isContentAuthor, loggedInUser, isAccountOwner, isContentAdmin } = this.props;
        const companyId = loggedInUser && loggedInUser.companyId;
        const userProfileId = loggedInUser && loggedInUser._id;
        const filteredFilesMetadata = this._filterMetaData(filesMetadata);

        return (
            <Page className={'media-library'}>
                <PageHeader
                    title={'Media Library'}
                    className={'adminTableHeaderTabs adminPageHeader'}
                    hideBackButton={true}
                />
                <div className={'media-library-page container'}>
                    <br />
                    {isVerbAdmin || isContentAuthor || isContentAdmin ? (
                        <div className={'row'}>
                            <Link className={'media-library-new-file-link'} to={'/newmedialibraryfile'}>
                                <VerbButton buttonText={'NEW FILE'} fontAwesomeIcon={'fa-plus'} />
                            </Link>
                        </div>
                    ) : null}
                    <br />
                    <VerbTable className={'media-library-table'}>
                        <thead>
                            <tr>
                                <th>ACTIONS</th>
                                <th>NAME</th>
                                <th>SIZE</th>
                                <th>UPLOADED DATE</th>
                            </tr>
                        </thead>
                        {filteredFilesMetadata.map((fileMetadata, index) => (
                            <MediaLibraryRow
                                fileMetadata={fileMetadata}
                                index={index}
                                setCopiedUrl={this.setCopiedUrl}
                                isEditing={fileMetadata.key === currentFileEditKey}
                                handleDeleteFile={this.handleDeleteFile}
                                downloadFile={(key) => getFileWithSignedUrl(this.context.pathsWeb, key)}
                                key={`${fileMetadata.key}-${index}`}
                                isVerbAdmin={isVerbAdmin}
                                isAccountOwner={isAccountOwner}
                                loggedInUser={loggedInUser}
                                canEdit={
                                    (isAccountOwner &&
                                        companyId === fileMetadata.uploadedBy.companyId &&
                                        !fileMetadata.isPublic) ||
                                    isVerbAdmin ||
                                    userProfileId === fileMetadata.uploadedBy.userProfileId
                                } // can edit if compAdmin and is uploaded by a user in their company and is not public file, if is verbadmin, if uploaded by themselves
                            />
                        ))}
                    </VerbTable>
                    <div className={'copy-url-message'}>
                        {this.state.copiedUrl && `${this.state.copiedUrl} copied!`}
                    </div>
                </div>
            </Page>
        );
    }
}

const mapStateToProps = (state) => {    
    const { teams, auth: { isVerbAdmin = false, isContentAdmin = false } } = state;
    return {
        teamsById: teams.byId || {},
        isVerbAdmin,
        isContentAdmin
    };
};

const mapDispatchToProps = (dispatch) => ({
    getManyTeamsAdmin: (params) => dispatch(getManyTeamsAdmin(params))
});

export const MediaLibraryComponent = MediaLibrary;
export default connect(mapStateToProps, mapDispatchToProps)(MediaLibrary);
